import { render } from "./headerContrat.vue?vue&type=template&id=aa7caed4"
import script from "./headerContrat.vue?vue&type=script&lang=ts"
export * from "./headerContrat.vue?vue&type=script&lang=ts"
script.render = render

export default script